import { tokens } from '@cellula/react-theme-patient';
import { SelectedAppointmentCase } from './selected_appointment_case.component';
import { SelectedMessagingCase } from './selected_messagingCase.component';
import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { Outlet, Route, Routes } from 'react-router';
import styled from 'styled-components';
import { Bleed, Flex, Grid } from '@cellula/react';
import { ListRoot } from './list_root.component';
import { Heading } from './heading.component';
import { useUser } from '@application/authentication/use_user';
import { SignInEmptyState } from './_sign_in_empty_state.component';

export function LegacyShell3Layout() {
	return (
		<Routes>
			<Route element={<PageOutlet />}>
				<Route path='/' element={null} />
				<Route
					path='/video/:callticket'
					element={
						<StyledAppointmentWrapper>
							<SelectedAppointmentCase />
						</StyledAppointmentWrapper>
					}
				/>
				<Route
					path='/message/:messageId'
					element={
						<StyledMessagingWrapper>
							<SelectedMessagingCase />
						</StyledMessagingWrapper>
					}
				/>
				<Route path='/*' element={<ViewNotFound />} />
			</Route>
		</Routes>
	);
}

const StyledAppointmentWrapper = styled.div`
	background-color: ${tokens.color.bg.surface};
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	margin-top: 40px;
	position: relative;

	${tokens.breakpointQuery.medium} {
		width: 100%;
		height: auto;
		border-radius: 16px;
		border: 1px solid ${tokens.color.border.default};
	}
`;

const StyledMessagingWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${tokens.color.bg.surface};
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	margin-top: 40px;
	position: relative;

	${tokens.breakpointQuery.medium} {
		width: 100%;
		height: 605px;
		border-radius: 16px;
		border: 1px solid ${tokens.color.border.default};
	}
`;

function PageOutlet() {
	const user = useUser();

	return (
		<Flex
			gap={tokens.spacing.x2}
			style={{
				margin: `${tokens.size.x5} auto 0`,
				padding: `0 ${tokens.spacing.x2}`,
			}}
		>
			<Heading bleed={false} />

			{user == null ? (
				<>
					<SignInEmptyState />

					{/* A bit of a hack to get the tab bar to function */}
					<div style={{ display: 'none' }}>
						<ListRoot />
					</div>
				</>
			) : (
				<Grid
					areas={{
						base: [
							// prettier-ignore
							'cases',
							'infoView',
						],
						M: [
							// prettier-ignore
							'cases  infoView',
						],
					}}
					columns={{
						base: ['4fr'],
						M: ['5fr', '7fr'],
					}}
					gap={{
						base: tokens.spacing.x2,
						M: `${tokens.spacing.x5} ${tokens.spacing.x3}`,
					}}
				>
					<Flex gridArea='cases'>
						<Bleed bleedAmount='16px'>
							<ListRoot />
						</Bleed>
					</Flex>
					<Flex gridArea='infoView'>
						<Outlet />
					</Flex>
				</Grid>
			)}
		</Flex>
	);
}
